import React from 'react'
import Button from './Button'
import getData from '../../functions/getData'
import { AUTH_CAPS } from '../../constants/state'
import { EDIT_PROGRAM_CAP } from '../../constants/caps'
import hasCap from '../../functions/hasCap'
import { connect } from 'react-redux'
import toJS from '../../containers/general/toJS'
import getDisabledClass from '../../functions/getDisabledClass'


const mapStateToProps = state => ({
    caps: getData(state, AUTH_CAPS)
})

const ButtonSubmitCancel = ({
    transIdCancel, 
    transIdSubmit,
    onCancel, 
    onSubmit, 
    disabledCancel = false, 
    disabledSubmit= false, 
    wrapperClassName = 'buttons-submit-cancel', 
    caps, 
    cap=EDIT_PROGRAM_CAP
}) => {
    const disableTemporarily = disabledSubmit
    const disablePermanently = !hasCap(caps, cap)

    return (
        <div className={getDisabledClass(wrapperClassName, disableTemporarily, disablePermanently)}>
            <Button
                className="button-cancel"
                transId={transIdCancel}
                onClick={onCancel}
                disabled={disabledCancel}
                hideText={false}
                type="button"
            />

            <Button
                className="button-submit"
                transId={transIdSubmit}
                onClick={onSubmit}
                disabled={disableTemporarily || disablePermanently}
                hideText={false}
                type="submit"
            />
        </div>
    )
}


export default connect(mapStateToProps)(toJS(ButtonSubmitCancel))